import React, { createContext, useContext } from "react";
import type { FieldValues } from "react-hook-form";
import type { BusinessFormProps } from "@src/components/business-form";

/** Поведение host-слоя (например mobile form window), без привязки к конкретному UI. */
export interface FormPanelHostValue {
    onRequestDismiss: () => void;
    wrapOnSubmit: <TFieldValues extends FieldValues>(
        onSubmit: BusinessFormProps<TFieldValues>["onSubmit"],
    ) => NonNullable<BusinessFormProps<TFieldValues>["onSubmit"]>;
    dirtyTrackingEnabled: boolean;
    setDirtyTrackingRoot: (element: HTMLDivElement | null) => void;
    hasUnsavedChanges: boolean;
}

const FormPanelHostContext = createContext<FormPanelHostValue | null>(null);

/** Провайдер host-поведения (задаётся `defineMobileFormWindow`, не в бизнес-компонентах). */
export function FormPanelHostProvider({ value, children }: { value: FormPanelHostValue; children: React.ReactNode }) {
    return <FormPanelHostContext.Provider value={value}>{children}</FormPanelHostContext.Provider>;
}

/** Host-поведение формы, если компонент открыт через `defineMobileFormWindow`. */
export function useFormPanelHost(): FormPanelHostValue | null {
    return useContext(FormPanelHostContext);
}
